"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfVaccineDeclinationDto = instanceOfVaccineDeclinationDto;
exports.VaccineDeclinationDtoFromJSON = VaccineDeclinationDtoFromJSON;
exports.VaccineDeclinationDtoFromJSONTyped = VaccineDeclinationDtoFromJSONTyped;
exports.VaccineDeclinationDtoToJSON = VaccineDeclinationDtoToJSON;
exports.VaccineDeclinationDtoToJSONTyped = VaccineDeclinationDtoToJSONTyped;
const VaccinationDeclinationReason_1 = require("./VaccinationDeclinationReason");
/**
 * Check if a given object implements the VaccineDeclinationDto interface.
 */
function instanceOfVaccineDeclinationDto(value) {
    if (!('agreement' in value) || value['agreement'] === undefined)
        return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined)
        return false;
    if (!('reasons' in value) || value['reasons'] === undefined)
        return false;
    return true;
}
function VaccineDeclinationDtoFromJSON(json) {
    return VaccineDeclinationDtoFromJSONTyped(json, false);
}
function VaccineDeclinationDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'agreement': json['agreement'],
        'createdAt': (json['createdAt'] == null ? null : new Date(json['createdAt'])),
        'reasons': (json['reasons'].map(VaccinationDeclinationReason_1.VaccinationDeclinationReasonFromJSON)),
    };
}
function VaccineDeclinationDtoToJSON(json) {
    return VaccineDeclinationDtoToJSONTyped(json, false);
}
function VaccineDeclinationDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'agreement': value['agreement'],
        'createdAt': (value['createdAt'] == null ? null : value['createdAt'].toISOString()),
        'reasons': (value['reasons'].map(VaccinationDeclinationReason_1.VaccinationDeclinationReasonToJSON)),
    };
}
//# sourceMappingURL=VaccineDeclinationDto.js.map